import { configureStore } from '@reduxjs/toolkit';

import authReducer, { getSavedAuthInfoFromLocalStorage } from 'features/auth/authSlice';
import backdropReducer from 'features/backdrop/backdropSlice';
import clientOverviewReducer from 'features/client/clientOverviewSlice';
import customReportReducer from 'features/custom-report/customReportSlice';
import dialogReducer from 'features/dialog/dialogSlice';
import floatProgressReducer from 'features/float-progress/floatProgressSlice';
import languageReducer from 'features/languages/languageSlice';
import userDetailReducer from 'features/users/userDetailSlice';

export const store = configureStore({
  reducer: {
    languages: languageReducer,
    auth: authReducer,
    dialog: dialogReducer,
    floatProgress: floatProgressReducer,
    backdrop: backdropReducer,
    userDetail: userDetailReducer,
    customReport: customReportReducer,
    clientOverview: clientOverviewReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'auth/saveLoginInfo',
          'auth/refreshToken/fulfilled',
          'dialog/openDialog',
          'auth/verifyUser/fulfilled',
        ],
        ignoredPaths: ['auth.user', 'dialog'],
      },
    }),
  preloadedState: {
    auth: getSavedAuthInfoFromLocalStorage() ?? {},
  },
  devTools: { latency: 0 },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
